import clientData from 'utils/client-data'

export function getUserId() {
  const {
    user: { customerId, nsId },
  } = clientData

  if (customerId === 'guest') {
    return nsId
  }

  return customerId
}

export function updateCartStorage(cartValue) {
  const key = 'pp-shops-cart-' + getUserId()
  localStorage.setItem(key, cartValue)
}

export function getCartStorage() {
  const key = 'pp-shops-cart-' + getUserId()
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {}
}

export function removeCartStorage() {
  const key = 'pp-shops-cart-' + getUserId()
  localStorage.removeItem(key)
}
